/*=============================================
=            Menu style                       =
=============================================*/
@import './pk-menu.variables';

:host {
  @apply block;
}

.pk-menu {
  @apply m-0 box-border h-full w-full overflow-auto rounded-[--menu--border-radius] bg-[color:--menu--background-color] p-0 pb-[--menu--padding-bottom] pt-[--menu--padding-top];
  @apply focus:outline-none;
}

.pk-menu__header,
.pk-menu__footer {
  @apply m-0 ml-[--menu--padding-left] mr-[--menu--padding-right] p-0;

  ::slotted(*) {
    @apply m-0 p-0;
  }
}

.pk-menu__header {
  &:not(.is-empty) {
    @apply mb-[--menu-header--margin-bottom];
  }

  ::slotted(*) {
    @apply text-[length:--menu-header--font-size] text-[color:--menu-header--color];

    font-family: var(--menu-header--font-family);
  }
}

.pk-menu__footer {
  &:not(.is-empty) {
    @apply mt-[--menu-footer--margin-top];
  }

  ::slotted(*) {
    @apply text-[length:--menu-footer--font-size] text-[color:--menu-footer--color];

    font-family: var(--menu-footer--font-family);
  }
}

.pk-menu__divider {
  @apply flex [--pk-divider-color:--pk-ui-01];

  &.hidden {
    display: none;
  }
}
